export const NotFound = () => <div>404 Not found</div>
